(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-card-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.hnCardsReady === '1') return;
      root.dataset.hnCardsReady = '1';
      var track = root.querySelector('[data-hn-cards-track]');
      if (!track) return;
      var prev = root.querySelector('[data-hn-cards-prev]');
      var next = root.querySelector('[data-hn-cards-next]');

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function init() {
      document.querySelectorAll('[data-hn-cards]').forEach(initSection);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-clinical-evidence"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.hnCeReady === '1') return;
      root.dataset.hnCeReady = '1';

      var overlay = root.querySelector('[data-hn-ce-overlay]');
      var fab = root.querySelector('[data-hn-ce-open]');
      var anchor = root.querySelector('.hn-ce__anchor');
      if (!overlay) return;

      // A transformed ancestor would make position:fixed resolve against it,
      // so the overlay is re-parented to <body> before it is shown.
      function open() {
        if (overlay.parentElement !== document.body) document.body.appendChild(overlay);
        overlay.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }

      function close() {
        overlay.hidden = true;
        document.documentElement.style.overflow = '';
      }

      if (fab) fab.addEventListener('click', open);
      root.querySelectorAll('[data-hn-ce-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !overlay.hidden) close();
      });

      // Any in-page link pointing at the anchor opens the dialog.
      if (anchor && anchor.id) {
        document.querySelectorAll('a[href="#' + anchor.id + '"]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            open();
          });
        });
      }

      var tabs = root.querySelectorAll('[data-hn-ce-tab]');
      var panels = root.querySelectorAll('[data-hn-ce-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = tab.getAttribute('data-hn-ce-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-hn-ce-panel') !== index;
          });
        });
      });

      if (fab) {
        var threshold = parseInt(root.dataset.showAfter || '0', 10);
        var scroller = document.querySelector('.page-wrapper') || window;
        var read = function () {
          return scroller === window ? window.scrollY : scroller.scrollTop;
        };
        var onScroll = function () {
          fab.hidden = read() < threshold;
        };
        scroller.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }

    function init() {
      document.querySelectorAll('[data-hn-ce]').forEach(initSection);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.hnCmpReady === '1') return;
      root.dataset.hnCmpReady = '1';
      var tabs = root.querySelectorAll('[data-hn-cmp-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var which = tab.getAttribute('data-hn-cmp-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          root.querySelectorAll('[data-hn-cmp-a]').forEach(function (el) {
            el.hidden = which !== 'a';
          });
          root.querySelectorAll('[data-hn-cmp-b]').forEach(function (el) {
            el.hidden = which !== 'b';
          });
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-hn-cmp]').forEach(initSection);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-expert-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (section.dataset.hnExpertsReady === '1') return;
      section.dataset.hnExpertsReady = '1';

      var track = section.querySelector('[data-hn-experts-track]');
      if (!track) return;

      var prev = section.querySelector('[data-hn-experts-prev]');
      var next = section.querySelector('[data-hn-experts-next]');
      var bar = section.querySelector('[data-hn-experts-progress]');

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        if (bar && bar.parentElement) {
          var visible = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
          var lane = bar.parentElement.clientWidth;
          bar.style.width = Math.max(lane * visible, 24) + 'px';
          var ratio = max > 0 ? track.scrollLeft / max : 0;
          bar.style.transform = 'translateX(' + ratio * (lane - bar.offsetWidth) + 'px)';
        }
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function init() {
      document.querySelectorAll('[data-hn-experts]').forEach(initSection);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.hnSpReady === '1') return;
      root.dataset.hnSpReady = '1';
      var tabs = root.querySelectorAll('[data-hn-sp-tab]');
      var panels = root.querySelectorAll('[data-hn-sp-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = tab.getAttribute('data-hn-sp-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-hn-sp-panel') !== index;
          });
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-hn-sp]').forEach(initSection);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (section.dataset.hnUgcReady === '1') return;
      section.dataset.hnUgcReady = '1';

      var track = section.querySelector('[data-hn-ugc-track]');

      section.querySelectorAll('[data-hn-ugc-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('.hn-ugc__card');
          var video = card && card.querySelector('video');
          if (!video) return;
          if (video.paused) {
            section.querySelectorAll('.hn-ugc__card.is-playing').forEach(function (other) {
              if (other === card) return;
              var v = other.querySelector('video');
              if (v) v.pause();
              other.classList.remove('is-playing');
            });
            video.muted = false;
            video.play();
            card.classList.add('is-playing');
          } else {
            video.pause();
            card.classList.remove('is-playing');
          }
        });
      });

      section.querySelectorAll('.hn-ugc__card video').forEach(function (video) {
        video.addEventListener('pause', function () {
          var card = video.closest('.hn-ugc__card');
          if (card) card.classList.remove('is-playing');
        });
        video.addEventListener('click', function () {
          var card = video.closest('.hn-ugc__card');
          if (!card) return;
          if (video.paused) {
            video.play();
            card.classList.add('is-playing');
          } else {
            video.pause();
          }
        });
      });

      if (!track) return;

      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-hn-ugc-dot]'));
      var slides = Array.prototype.slice.call(track.children);

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = slides[parseInt(dot.dataset.hnUgcDot, 10)];
          if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });

      if (dots.length) {
        track.addEventListener(
          'scroll',
          function () {
            var index = 0;
            var best = Infinity;
            slides.forEach(function (slide, i) {
              var delta = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
              if (delta < best) {
                best = delta;
                index = i;
              }
            });
            dots.forEach(function (dot, i) {
              if (i === index) dot.setAttribute('aria-current', 'true');
              else dot.removeAttribute('aria-current');
            });
          },
          { passive: true }
        );
      }
    }

    function init() {
      document.querySelectorAll('[data-hn-ugc]').forEach(initSection);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();
})();
